import { render } from "./still-image.vue?vue&type=template&id=75385b10"
import script from "./still-image.js?vue&type=script&lang=js"
export * from "./still-image.js?vue&type=script&lang=js"

import "./still-image.vue?vue&type=style&index=0&id=75385b10&lang=scss"

import exportComponent from "/builds/pleroma/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__